module.exports = __webpack_public_path__ + "img/kk.65044aaf.png";